import DashboardLayout from "@/layouts/DashboardLayout.vue";
import PedidosPendientes from "../views/PedidosPendientesView.vue";
import PedidosPagadosView from "../views/PedidosPagadosView.vue";
import PedidosCompletadosView from "../views/PedidosCompletadosView.vue";

const routes = [
  {
    path: "/pedidos",
    component: DashboardLayout,
    children: [
      {
        path: "",
        redirect: { name: "PedidosPendientes" },
      },
      {
        path: "pendientes",
        name: "PedidosPendientes",
        component: PedidosPendientes,
        meta: {
          /** Ver AppSidebar: quien puede ver «Pagados» también entra a Pendientes si falta el permiso nuevo en BD. */
          permissions: [
            "baret_navbar:pedidosPendientes",
            "baret_navbar:pedidosPagados",
          ],
        },
      },
      {
        path: "pagados",
        name: "PedidosPagados",
        component: PedidosPagadosView,
        meta: {
          permissions: "baret_navbar:pedidosPagados",
        },
      },
      {
        path: "completados",
        name: "PedidosCompletados",
        component: PedidosCompletadosView,
        meta: {
          permissions: "baret_navbar:pedidosCompletados",
        },
      },
    ],
  },
];

export default routes;
